import React from "react";
import type { HTMLAttributes } from "react";
import { BrandSymbol } from "./BrandSymbol";

export const BrandLogo: React.FC<HTMLAttributes<HTMLSpanElement>> = ({ className = "", ...props }) => (
  <span className={`brand-logo ${className}`} {...props}>
    <BrandSymbol alt="" />
    <span className="brand-wordmark">Team<span>Assess</span></span>
  </span>
);

export default BrandLogo;
